import { HTMLProps } from 'react';
import { useRouter } from 'next/router';
import { Trans, useTranslation } from 'next-i18next';
import { cn, getChannelTalkSupportArticleUrl, isEuropeByTimeZone } from '@zep/utils';
const LoginPrivacyPolicy = (props: HTMLProps<HTMLSpanElement>) => {
  const {
    locale = 'ko'
  } = useRouter();
  const {
    t
  } = useTranslation(['common']);
  const {
    className,
    ...rest
  } = props;
  const privacy = t('common:signin.terms.privacy');
  const terms = t('common:signin.terms.terms');
  if (isEuropeByTimeZone()) {
    return null;
  }
  return <span className={cn('text-gray-600 text-center text-[12px] px-[24px] md:px-[34px]', className)} {...rest} data-sentry-component="LoginPrivacyPolicy" data-sentry-source-file="loginPrivacyPolicy.tsx">
      <Trans t={t} i18nKey={'common:signin.terms.description'} values={{
      privacy: privacy,
      terms
    }} components={{
      P: <a className="cursor-pointer underline hover:text-[#0a58ca]" href={getChannelTalkSupportArticleUrl(locale, '8232ed3d')} target="_blank" rel="noreferrer" />,
      T: <a className="cursor-pointer underline hover:text-[#0a58ca]" href={getChannelTalkSupportArticleUrl(locale, 'b40ac18f')} target="_blank" rel="noreferrer" />
    }} data-sentry-element="Trans" data-sentry-source-file="loginPrivacyPolicy.tsx" />
    </span>;
};
export { LoginPrivacyPolicy };